/**
 * @flow
 * @relayHash 236ff8ab99d9582338bc1def81a1da42
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteTenantMutationVariables = {|
  id: string
|};
export type DeleteTenantMutationResponse = {|
  +deleteTenant: {|
    +id: string
  |}
|};
export type DeleteTenantMutation = {|
  variables: DeleteTenantMutationVariables,
  response: DeleteTenantMutationResponse,
|};
*/


/*
mutation DeleteTenantMutation(
  $id: String!
) {
  deleteTenant(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteTenant",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TenantModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteTenantMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteTenantMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteTenantMutation",
    "id": null,
    "text": "mutation DeleteTenantMutation(\n  $id: String!\n) {\n  deleteTenant(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '20424fdd3f39a70212dcea0cd27449a3';
module.exports = node;
